import { Disclosure } from "@headlessui/react";
import { MinusSmallIcon, PlusSmallIcon } from "@heroicons/react/24/outline";
import { Link } from "gatsby";
import React from "react";

import { clientUrl } from "../../constants/site-urls";

const faqs = [
  {
    question: "What level of experience is needed for this kit?",
    answer: () =>
      "None! You can get value out of the kit if you're a total beginner making your first extension or a seasoned pro who wants to save time. It is recommended, however, that you have a bit of knowledge in HTML, CSS, and JS. React and Vue templates would also require a bit of React or Vue knowledge, respectively.",
  },
  {
    question: "What is a starter template?",
    answer: () => (
      <span>
        A starter template is a barebones Chrome Extension that provides you
        with a starting point to begin working on your project right away. They
        include manifests, base files, and config for a variety of different
        extension development use cases.{" "}
        <a
          className="text-emerald-500 underline"
          href={`${clientUrl}/template/basic-popup`}
        >
          Click here
        </a>{" "}
        to take a look at a basic, free starter template.
      </span>
    ),
  },
  {
    question: "Can I use the kit for any project?",
    answer: () => (
      <span>
        Yes, the templates can be used for any number of personal or commercial
        projects, however you cannot resell or redistribute the templates or any
        derivatives (such as other templates based off these templates). To view
        the complete license,{" "}
        <Link className="text-emerald-500 underline" to="/license">
          click here
        </Link>
        .
      </span>
    ),
  },
  {
    question: "Can I browse the templates before purchase?",
    answer: () => (
      <span>
        Of course! You can view all templates (including free ones that can be
        downloaded without purchase) on the{" "}
        <a className="text-emerald-500 underline" href={clientUrl}>
          template tab
        </a>
        .
      </span>
    ),
  },
  {
    question: "What is the refund policy?",
    answer: () => (
      <span>
        Within 14 days of purchase, if you aren't satisfied with the kit,{" "}
        <Link className="text-emerald-500 underline" to="/contact">
          reach out
        </Link>{" "}
        and you'll get a full refund. No questions asked.
      </span>
    ),
  },
];

const FAQs = () => {
  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <div className="mx-auto max-w-2xl divide-y divide-slate-900/10">
        <h2 className="text-2xl font-bold leading-10 tracking-tight text-slate-900">
          Frequently asked questions
        </h2>
        <dl className="mt-10 space-y-6 divide-y divide-slate-900/10">
          {faqs.map((faq) => (
            <Disclosure as="div" key={faq.question} className="pt-6">
              {({ open }) => (
                <>
                  <dt>
                    <Disclosure.Button className="flex w-full items-start justify-between text-left text-slate-900">
                      <span className="text-base font-semibold leading-7">
                        {faq.question}
                      </span>
                      <span className="ml-6 flex h-7 items-center">
                        {open ? (
                          <PlusSmallIcon
                            className="h-6 w-6"
                            aria-hidden="true"
                          />
                        ) : (
                          <MinusSmallIcon
                            className="h-6 w-6"
                            aria-hidden="true"
                          />
                        )}
                      </span>
                    </Disclosure.Button>
                  </dt>
                  <Disclosure.Panel as="dd" className="mt-2 pr-12">
                    <p className="text-base leading-7 text-slate-600">
                      {faq.answer()}
                    </p>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          ))}
        </dl>
      </div>
    </div>
  );
};

export default FAQs;
